module.exports = __webpack_public_path__ + "img/SJGL.4ba7b8e5.png";